// extracted by mini-css-extract-plugin
module.exports = {"root":"LimitedAccessBanner_root__2oBNR","text":"LimitedAccessBanner_text__OdFwI","button":"LimitedAccessBanner_button__2IAjg"};